import {isTaskLockedByFinalizedInvoice, type InvoiceLookup} from '@/Financial/Invoices/finalizedLock';
import type Task from '@/entities/task';
import type {ReactElement} from 'react';

/** Keep the invoice restriction ahead of the existing delete-impact calculation. */
export function associatedTaskDeletion(
    task: Pick<Task, 'id' | 'invoiceId'>,
    invoices: InvoiceLookup,
    deleteImpact: () => {canDelete: boolean; message?: string | ReactElement},
): {canDelete: boolean; message: string | ReactElement} {
    if (task.invoiceId) {
        const invoice = invoices.get(task.invoiceId);
        if (invoice && invoice.status !== 'D') return {
            canDelete: false,
            message: `Associated with invoice ${invoice.invoiceNumber} [${invoice.id}]`,
        };
    }
    const finalizedInvoice = invoices.values().find(invoice => isTaskLockedByFinalizedInvoice(task, {
        get: id => id === invoice.id ? invoice : undefined,
        values: () => [invoice],
    }));
    if (finalizedInvoice) return {
        canDelete: false,
        message: `Associated with invoice ${finalizedInvoice.invoiceNumber} [${finalizedInvoice.id}]`,
    };
    const impact = deleteImpact();
    return {canDelete: impact.canDelete, message: impact.canDelete ? '' : impact.message ?? ''};
}
